import React, {startTransition, StrictMode} from "react";
import {hydrateRoot} from "react-dom/client";
import {HydratedRouter} from "react-router/dom";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import {initStore} from "../app/store/store";
import Locales from "../app/components/Locales";
import {Suspense} from "react";
import {WebSocketProvider} from "../app/websocket/context/index";

import "./posthog";
import "react-datepicker/dist/react-datepicker.css";
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "aos/dist/aos.css";
import "react-toastify/dist/ReactToastify.css";
import "@housebets/housebets-x-package/lib/index.css";
import "./index.scss";
import {LocalType} from "./types/common";
import {loadLocaleData} from "./utils/locales";
import {ScreenLoader} from "@housebets/housebets-x-package";

declare global {
    interface Window {
        __LOCALE__?: string;
        __MESSAGES__?: Record<string, any>;
        __PRELOADED_STATE__?: any;
    }
}

const locale = window.__LOCALE__ || LocalType.En;
const messages = window.__MESSAGES__ || {};
const preloadedState = window.__PRELOADED_STATE__;
// localStorage.removeItem("persist:root");
const {store, persistor} = initStore(preloadedState);
startTransition(() => {
    hydrateRoot(
        document,
        <>
            <Suspense
                fallback={
                    <div style={{backgroundColor: "#08161b", height: "100vh", width: "100vw", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div style={{width: "100px", height: "100%", position: "relative", display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            {typeof window !== undefined ? (
                                <Suspense>
                                    <ScreenLoader isFullPage />
                                </Suspense>
                            ) : null}
                        </div>
                    </div>
                }>
                <Provider store={store}>
                    {persistor ? (
                        <PersistGate loading={null} persistor={persistor}>
                            <WebSocketProvider initialUrl={preloadedState?.config?.platformConfig?.webSocketUrl || null}>
                                <Locales locale={locale} messages={messages}>
                                    <HydratedRouter />
                                </Locales>
                            </WebSocketProvider>
                        </PersistGate>
                    ) : (
                        <WebSocketProvider initialUrl={preloadedState?.config?.platformConfig?.webSocketUrl || null}>
                            <Locales locale={locale} messages={messages}>
                                <HydratedRouter />
                            </Locales>
                        </WebSocketProvider>
                    )}
                </Provider>
            </Suspense>
        </>,
    );
});
